const connectorAvailabilityRank = connector => {
  if (connector.status === 'connected') return 0;
  if (!connector.disabled && connector.status !== 'disabled') return 1;
  return 2;
};

export const sortConnectorsByAvailability = (connectors = []) => (
  connectors
    .map((connector, index) => ({ connector, index }))
    .sort((a, b) => (
      connectorAvailabilityRank(a.connector) - connectorAvailabilityRank(b.connector)
      || a.index - b.index
    ))
    .map(({ connector }) => connector)
);
